import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ScalarResponseModel } from "../../models/scalar/scalar.model";

@Injectable({
    providedIn: 'root'
})
export class NewTanksService {

    private NEWTANKS_URL = 'api/newTanks/{distrib}/{days}'

    constructor(
        private _httpClient: HttpClient
    ) {
    }

    get url(): string {

        return this.NEWTANKS_URL;
    }

    getTankData$(distributorCode: string, days: string): Observable<ScalarResponseModel> {
        let x = this.url.replace('{distrib}', "0");
        let y = x.replace('{days}', days);
        return this._httpClient.get<ScalarResponseModel>(`${y}`);
    }
}
